import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  h5 {\n    font-weight: 600;\n    line-height: 1.5;\n    font-size: 16px;\n    letter-spacing: -0.16px;\n    margin-bottom: 12px;\n    display: flex;\n    align-items: center;\n\n    svg {\n      margin-left: 4px;\n    }\n  }\n\n  .ant-divider-horizontal {\n    margin: 40px 0;\n  }\n\n  transition: all 0.5s ease-in-out;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  // @keyframes slideDown {\n  // 	from {\n  // 		max-height: 260px;\n  // 	}\n  // 	to {\n  // 		max-height: ",
        "px; /* 최대 높이를 조절하셔야 합니다. */\n  // 	}\n  // }\n  //\n  // @keyframes slideUp {\n  // 	from {\n  // 		max-height: ",
        "px; /* 최대 높이를 조절하셔야 합니다. */\n  // 	}\n  // 	to {\n  // 		max-height: 260px;\n  // 	}\n  // }\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  //height: ",
        "px; /* 최대 높이를 조절하셔야 합니다. */\n  gap: 4px;\n\n  //&.expanded {\n  //	animation: slideDown 0.5s forwards;\n  //}\n  //\n  //&.collapsed {\n  //	animation: slideUp 0.5s forwards;\n  //}\n  @media (max-width: 768px) {\n    gap: 0;\n    &.expanded,\n    &.collapsed {\n      animation: none;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  margin: 0 auto;\n  margin-top: 12px;\n  padding: 12px 20px;\n  width: 340px;\n  color: ",
        ";\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n\n  :hover {\n    color: ",
        " !important;\n    border: 1px solid ",
        " !important;\n    background-color: rgba(169, 175, 199, 0.2);\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n\n  body:has(&) {\n    .related-tooltip {\n    }\n\n    .related-tooltip:not(.ant-tooltip-hidden) {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FilledButton from "@/components/common/Button/FilledButton";
import Icon from "@/components/icon/Icon";
import { InfoCircle, Sizes } from "@/components/icon/IconList";
import { Title } from "@/components/Product/Handout";
import { TooltipItem } from "@/components/Product/Handout/HandoutAllowanceChip";
import { RelatedProductPreviewModal } from "@/components/Product/Handout/RelatedProducts/RelatedProductPreviewModal";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { useQuery } from "@tanstack/react-query";
import { Tooltip } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import useHandoutProductStore from "src/store/relatedProduct";
import styled from "styled-components";
import { getRelatedProducts } from "../../../../api/product";
import { SectionWithDivider } from "../SectionWithDivider";
import { MobileDisplayAllRelatedProduct } from "./MobileDisplayAllRelatedProduct";
import { RelatedListItem } from "./RelatedListItem";
/** 무료체험 가능 여부 확인 (Case 1) */ const isEligibleForFreeTrial = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.isEligible || freeTrialData.reason === "not_logged_in";
};
/** 무료획득으로 보유 여부 확인 (Case 3) */ const isAlreadyOwned = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.reason === "already_owned" && freeTrialData.isFreeOwned === true;
};
export const RelatedProduct = (param)=>{
    let { product , isFreepass , freeTrialData , hasAdBanner  } = param;
    const { isMobile  } = useWindowDimensions();
    const { data: relatedProductResponse  } = useQuery([
        "relatedProduct",
        product.id
    ], ()=>getRelatedProducts(product.id.toString()));
    const { relatedProducts , updateRelatedProducts , setHasAlreadyOwned  } = useHandoutProductStore((state)=>({
            relatedProducts: state.relatedProducts,
            updateRelatedProducts: state.updateRelatedProducts,
            setHasAlreadyOwned: state.setHasAlreadyOwned
        }));
    const [displayAll, setDisplayAll] = useState(false);
    const [isOpenSideSheet, setIsOpenSideSheet] = useState(false);
    const DEFAULT_DISPLAY_COUNT = 4;
    const toggleDisplayAllRelatedItems = useCallback(()=>{
        if (!displayAll) {
            mixpanelEvent("More Button Clicked", {
                "Button Type": "연관자료",
                "Button Name": "연관자료 전체보기"
            });
        }
        if (isMobile && !displayAll) {
            setIsOpenSideSheet(true);
            return;
        }
        setDisplayAll((prev)=>!prev);
    }, [
        isMobile
    ]);
    const displayList = useMemo(()=>{
        if (!relatedProducts) return [];
        return displayAll ? relatedProducts : relatedProducts.slice(0, DEFAULT_DISPLAY_COUNT);
    }, [
        displayAll,
        relatedProducts
    ]);
    useEffect(()=>{
        //지금 보고있는 자료 업데이트
        if (!!relatedProductResponse) {
            //이미 소유한 자료인지 업데이트
            setHasAlreadyOwned(relatedProductResponse.hasAlreadyOwned || false);
            //연관자료 리스트 업로드
            updateRelatedProducts(relatedProductResponse.data);
        }
    }, [
        relatedProductResponse
    ]);
    // Case 1, Case 3: 무료체험 가능 또는 무료획득으로 보유한 경우 다른 단원도 구매하기 섹션 미노출
    // 광고 배너(쏠북 소식)도 없을 때만 divider 표시
    if (isEligibleForFreeTrial(freeTrialData) || isAlreadyOwned(freeTrialData)) {
        if (!hasAdBanner) {
            return /*#__PURE__*/ _jsx("div", {
                className: "border-t border-gray-100 my-12"
            });
        }
        return null;
    }
    if (relatedProducts.length === 0) return null;
    return /*#__PURE__*/ _jsxs(SectionWithDivider, {
        children: [
            /*#__PURE__*/ _jsxs(RelatedListLayout, {
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        children: /*#__PURE__*/ _jsxs(CustomTooltip, {
                            hasInfo: true,
                            showArrow: true,
                            placement: "top",
                            color: "white",
                            overlayStyle: {
                                width: "100%"
                            },
                            overlayInnerStyle: {
                                display: "block",
                                backgroundColor: "white",
                                boxShadow: "6px 6px 20px 0px rgba(28, 31, 46, 0.12)",
                                maxWidth: "410px",
                                width: "100%",
                                flexGrow: 1,
                                padding: "20px"
                            },
                            overlayClassName: "related-tooltip",
                            title: /*#__PURE__*/ _jsx(TooltipItem, {
                                title: "연관 자료 함께 구매하기",
                                description: "현재 보고 있는 수업자료와 동일한 저자, 출처 교재, 자료 유형의 수업자료들을 함께 구매할 수 있는 영역이에요. 필요한 자료를 선택 후 이용권을 사용하거나 장바구니에 담을 수 있어요.",
                                productType: "handout",
                                linkTitle: null,
                                link: null
                            }),
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    children: "다른 단원도 구매하기"
                                }),
                                /*#__PURE__*/ _jsx(Icon, {
                                    icon: InfoCircle,
                                    size: Sizes.small
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(RelatedListContainer, {
                        className: displayAll ? "expanded" : "collapsed",
                        children: displayList.map((product)=>/*#__PURE__*/ _jsx(RelatedListItem, {
                                product: product,
                                isFreepass: isFreepass
                            }, product.id))
                    }),
                    relatedProducts.length > DEFAULT_DISPLAY_COUNT && /*#__PURE__*/ _jsx(ShowMoreButton, {
                        onClick: toggleDisplayAllRelatedItems,
                        children: displayAll ? "접기" : "전체보기"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(RelatedProductPreviewModal, {}),
            /*#__PURE__*/ _jsx(MobileDisplayAllRelatedProduct, {
                isOpenSideSheet: isOpenSideSheet,
                closeSideSheet: ()=>setIsOpenSideSheet(false),
                isFreepass: isFreepass
            })
        ]
    });
};
const RelatedListLayout = styled.div.withConfig({
    componentId: "sc-de43361d-0"
})(_templateObject());
const RelatedListContainer = styled.div.withConfig({
    componentId: "sc-de43361d-1"
})(_templateObject1(), (props)=>props.maxHeight, (props)=>props.maxHeight, (props)=>props.maxHeight);
const ShowMoreButton = styled(FilledButton).withConfig({
    componentId: "sc-de43361d-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_100);
export const CustomTooltip = styled(Tooltip).withConfig({
    componentId: "sc-de43361d-3"
})(_templateObject3());
